import $ from "jquery";

export default (function() {
  var init = function() {
    $("#divMessages a").click(function() {
      $(".message").hide();
      $(".error").hide();
      return false;
    });

    $(".bl-messages a").click(function () {
        $(this).parent().remove();
        return false;
    });
  };

  return {
    init: init
  };
})();
